module.exports = __webpack_public_path__ + "8ba677b5d9485266b2d49283f6c1f2a2.jpg";